import React from 'react'
import { Text } from '@components/Text'
import { LinkForAppFeatures } from '@components/LinkForAppFeatures'
import { Link } from '@components/Link'
import type { NavigationItem } from '@helpers/getFooter'
import { notEmpty } from '@helpers/notEmpty'
import { LinkArrowIcon } from '@components/Icons/LinkArrowIcon'
import { useLocaliseString } from '@hooks/useLocaliseString'
import { trackGTM } from '@helpers/core/trackGTM'
import { useEventTracker } from '@hooks/useEventTracker'

type FooterNavigationItemsProps = {
  navigationItems: (NavigationItem | null | undefined)[]
  linkStyles: string
  hasEndIcon?: boolean
  groupName?: string | null | undefined
}

export const NewFooterTag = () => {
  const localiseString = useLocaliseString()

  return (
    <>
      <span className='text-10 md:text-[0.325rem] md:top-[-2px] relative text-neutral'>
        {' '}
        &nbsp;●&nbsp;{' '}
      </span>
      <Text variant='x-small' color='teal'>
        {localiseString('footerLabelNew')}
      </Text>
    </>
  )
}

const handleClick = (
  link: string,
  text: string,
  groupName?: string | null | undefined
) => {
  const isPDFDownload = link?.includes('.pdf')

  if (isPDFDownload) {
    trackGTM({
      event: 'pdf_download_click',
      text,
      // eslint-disable-next-line camelcase
      destination_url: link,
    })
  } else if (groupName) {
    trackGTM({
      event: 'footer click',
      text,
      group: groupName,
    })
  }
}

export const FooterNavigationItems = ({
  navigationItems,
  hasEndIcon = false,
  linkStyles,
  groupName,
}: FooterNavigationItemsProps) => {
  const { track } = useEventTracker()

  return (
    <>
      {navigationItems
        ?.filter(notEmpty)
        .reduce<JSX.Element[]>((footerItems, footerItem) => {
          const { link, text, trackingEvent } = footerItem

          if (link && text) {
            footerItems.push(
              <React.Fragment key={text}>
                <Link
                  url={link}
                  className={linkStyles}
                  onClick={() => {
                    if (trackingEvent) {
                      track({
                        action: trackingEvent,
                      })
                    }

                    handleClick(link, text, groupName)
                  }}
                >
                  {text}
                  {footerItem?.new && <NewFooterTag />}
                  {hasEndIcon && <LinkArrowIcon className='align-top w-16' />}
                </Link>
              </React.Fragment>
            )
          } else if (footerItem.pageLink) {
            const { pageLink, text } = footerItem
            const { type, slug } = pageLink

            if (slug && text) {
              footerItems.push(
                <React.Fragment key={text}>
                  <LinkForAppFeatures
                    slug={slug}
                    type={type}
                    className={linkStyles}
                    onClick={() => {
                      if (trackingEvent) {
                        track({
                          action: trackingEvent,
                        })
                      }

                      handleClick(slug, text, groupName)
                    }}
                  >
                    {footerItem.text}
                    {footerItem?.new && <NewFooterTag />}
                    {hasEndIcon && <LinkArrowIcon className='align-top w-16' />}
                  </LinkForAppFeatures>
                </React.Fragment>
              )
            }
          }

          return footerItems
        }, [])}
    </>
  )
}
